
import styles from './TrufflePage.module.css';
import { Container, Grid, GridColumn, GridRow } from "semantic-ui-react";
import CardTruffle1 from "./CardTruffle1";
import CardTruffle2 from "./CardTruffle2";
import CardTruffle3 from './CardTruffle3';
import CardTruffle4 from './CardTruffle4';

const TrufflePage = () => {
    return (
        <Container className={styles.container}>
            <Grid columns='equal'>
                <GridRow only='computer tablet' columns='equal'>
                    <GridColumn>
                        <CardTruffle1 />
                    </GridColumn>
                    <GridColumn>
                        <CardTruffle2 />
                    </GridColumn>
                </GridRow>
                <GridRow only='computer tablet' columns='equal'>
                    <GridColumn>
                        <CardTruffle3 />
                    </GridColumn>
                    <GridColumn>
                        <CardTruffle4 />
                    </GridColumn>
                </GridRow>
                <GridRow only='mobile'>
                    <GridColumn>
                        <CardTruffle1 />
                        <CardTruffle2 />
                        <CardTruffle3 />
                        <CardTruffle4 />
                    </GridColumn>
                </GridRow>
            </Grid>
        </Container>
    );
}

export default TrufflePage